import { render, staticRenderFns } from "./DialogCalificacionCentralizado.vue?vue&type=template&id=64b6b44e&scoped=true"
import script from "./DialogCalificacionCentralizado.vue?vue&type=script&lang=js"
export * from "./DialogCalificacionCentralizado.vue?vue&type=script&lang=js"
import style0 from "./DialogCalificacionCentralizado.vue?vue&type=style&index=0&id=64b6b44e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b6b44e",
  null
  
)

export default component.exports